// eslint-disable-next-line camelcase
import { legacy_createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const middleWares = [thunk];

const enhancer = compose(applyMiddleware(...middleWares));

const store = (initialState: object) => {
  return legacy_createStore(reducers, initialState, enhancer);
};

export default store;
